// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"2d2924f1","73":"f807a1fc","165":"78222e04","532":"55d46c5b","736":"cc357a7b","860":"f049b6c1","889":"61553df4"}[chunkId] + ".css";
};